import { render, staticRenderFns } from "./components.radio-button.vue?vue&type=template&id=7ca6a146"
import script from "./components.radio-button.vue?vue&type=script&lang=js"
export * from "./components.radio-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports